var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('ProgressSpinner',{attrs:{"strokeWidth":"4"}}),(!_vm.nomsg)?_c('div',{staticClass:"mt-3 lead"},[_vm._v("\n        "+_vm._s(_vm.msg ? _vm.msg : 'Carregando...')+" \n    ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }